import {
  AnnotationLayer,
  createObjectURL,
  createPromiseCapability,
  createValidAbsoluteUrl,
  getDocument,
  RenderingCancelledException,
  renderTextLayer,
} from "pdfjs-lib";

// start of TW overrides
let TWAnnotationLayer = null;

if (typeof AnnotationLayer === "undefined") {
  // eslint-disable-next-line no-undef
  TWAnnotationLayer = pdfjsLib.AnnotationLayer;
} else {
  TWAnnotationLayer = AnnotationLayer;
}

let TWcreateObjectURL = null;
if (typeof createObjectURL === "undefined") {
  // eslint-disable-next-line no-undef
  TWcreateObjectURL = pdfjsLib.createObjectURL;
} else {
  TWcreateObjectURL = createObjectURL;
}

let TWcreatePromiseCapability = null;
if (typeof createPromiseCapability === "undefined") {
  // eslint-disable-next-line no-undef
  TWcreatePromiseCapability = pdfjsLib.createPromiseCapability;
} else {
  TWcreatePromiseCapability = createPromiseCapability;
}

let TWcreateValidAbsoluteUrl = null;
if (typeof createValidAbsoluteUrl === "undefined") {
  // eslint-disable-next-line no-undef
  TWcreateValidAbsoluteUrl = pdfjsLib.createValidAbsoluteUrl;
} else {
  TWcreateValidAbsoluteUrl = createValidAbsoluteUrl;
}

let TWgetDocument = null;
if (typeof getDocument === "undefined") {
  // eslint-disable-next-line no-undef
  TWgetDocument = pdfjsLib.getDocument;
} else {
  TWgetDocument = getDocument;
}

let TWrenderTextLayer = null;
if (typeof renderTextLayer === "undefined") {
  // eslint-disable-next-line no-undef
  TWrenderTextLayer = pdfjsLib.renderTextLayer;
} else {
  TWrenderTextLayer = renderTextLayer;
}

let TWRenderingCancelledException = null;
if (typeof RenderingCancelledException === "undefined") {
  // eslint-disable-next-line no-undef
  TWRenderingCancelledException = pdfjsLib.RenderingCancelledException;
} else {
  TWRenderingCancelledException = RenderingCancelledException;
}

export {
  TWAnnotationLayer as AnnotationLayer,
  TWgetDocument as getDocument,
  TWcreateObjectURL as createObjectURL,
  TWcreateValidAbsoluteUrl as createValidAbsoluteUrl,
  TWcreatePromiseCapability as createPromiseCapability,
  TWrenderTextLayer as renderTextLayer,
  TWRenderingCancelledException as RenderingCancelledException,
};
